/**
 * @generated SignedSource<<6a6d37f1a05792f492569b6daa693503>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PostList_posts$data = {
  readonly pagination: {
    readonly currentPageNumber: number
    readonly lastPageNumber: number
  }
  readonly items: ReadonlyArray<{
    readonly slug: string
    readonly h1: string
    readonly image: {
      readonly alt: string | null
      readonly url: string
    } | null
    readonly modified_at: string
  }>
  readonly ' $fragmentType': 'PostList_posts'
}
export type PostList_posts$key = {
  readonly ' $data'?: PostList_posts$data
  readonly ' $fragmentSpreads': FragmentRefs<'PostList_posts'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'PostList_posts',
  selections: [
    {
      alias: null,
      args: null,
      concreteType: 'PaginationStatus',
      kind: 'LinkedField',
      name: 'pagination',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'currentPageNumber',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'lastPageNumber',
          storageKey: null
        }
      ],
      storageKey: null
    },
    {
      alias: null,
      args: null,
      concreteType: 'Post',
      kind: 'LinkedField',
      name: 'items',
      plural: true,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'slug',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'h1',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'PostImage',
          kind: 'LinkedField',
          name: 'image',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'alt',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'url',
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'modified_at',
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'PostResult',
  abstractKey: null
}

;(node as any).hash = 'def5b4d5497ae2a4ab99be51f86d2d04'

export default node
